import { Pipe, PipeTransform } from '@angular/core';
import { StageMonth } from '../shared';

// pipe permettant de trier les listes par ordres de mois utilisé dans stages-list.component.html

@Pipe({
  name: 'sortlist'
})

export class SortListPipe implements PipeTransform {

  constructor(
  ) { }

  transform(months: Array<StageMonth>): Array<StageMonth> {
    months.sort((a: StageMonth, b: StageMonth): number => {
      return a.MonthsNumber - b.MonthsNumber;
    });
    return months;
  }
}


